export default __webpack_public_path__ + "static/media/time.85688210.svg";